module.exports = __webpack_public_path__ + "img/logo.bf17bf98.png";